import React from 'react';
import clsx from 'clsx';

import {
  FocusHandler,
  EnterPressHandler,
  useFocusable
} from '@noriginmedia/norigin-spatial-navigation';
import Typography from '@smart-tv/components/typography/typography';
import ProgressSpinner from '../progress-spinner/progress-spinner';
import { isEnterKey, isSpaceKey } from '@smart-tv/utils/remoteKeys';

import styles from './list-item.module.scss';

interface Props {
  data: string[];
  onFocus?: FocusHandler;
  onEnterPress?: EnterPressHandler;
  listItemProps?: any;
}

export const ListItem: React.FC<Props> = (props: Props) => {
  const { data, onFocus, onEnterPress, listItemProps = {} } = props;

  const { focused, ref } = useFocusable({ onFocus, onEnterPress });

  const { className, ...restListItemProps } = listItemProps;

  const focusClassName = focused ? styles['list-item--focused'] : undefined;

  const rootClass = clsx(styles['list-item'], focusClassName, className);

  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (!onEnterPress) return;
    if (isEnterKey(event) || isSpaceKey(event)) {
      event.preventDefault();
      onEnterPress();
    }
  };

  return (
    <div
      ref={ref}
      className={rootClass}
      onClick={onEnterPress}
      onKeyDown={handleKeyDown}
      role={onEnterPress ? 'button' : undefined}
      tabIndex={onEnterPress ? 0 : undefined}
      {...restListItemProps}
    >
      {data.map((dataPoint, index) => (
        <Typography
          variant="caption2"
          key={index}
          className={styles['list-item__data']}
          style={{ width: `calc(100% / ${data.length})` }}
        >
          {dataPoint !== '' ? dataPoint : <ProgressSpinner size={30} />}
        </Typography>
      ))}
    </div>
  );
};

export default React.memo(ListItem);
